import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';

import { NotificationService } from '../services/notification.service';
import { AuthStore } from '../store/auth.store';

export const assessmentPortalGuard: CanActivateFn = () => {
  const auth = inject(AuthStore);
  const router = inject(Router);
  const notification = inject(NotificationService);

  return auth.loadSession().pipe(
    map((isAuthenticated) => {
      if (!isAuthenticated) {
        return router.createUrlTree(['/login']);
      }

      if (auth.hasRole(['EDUCATOR', 'SITEMANAGER'])) {
        return true;
      }

      if (auth.hasRole(['SUPERUSER'])) {
        return router.createUrlTree(['/admin']);
      }

      notification.showError('Your account is not assigned to the Assessment Portal.');
      return router.createUrlTree(['/help'], {
        queryParams: { topic: 'account-access' },
      });
    })
  );
};
